import { useMemo } from "react";
import {
  getWheelRaffleErrorMessage,
  selectBoard,
  useGetRafflesBoardQuery,
} from "entities/wheel-raffle";
import { RAFFLE_POLLING_MS } from "./constants";
import { useClientPage } from "./useClientPage";

export const useRafflesBoard = () => {
  // Свежий список при каждом открытии; дальше — поллинг участников.
  const result = useGetRafflesBoardQuery(undefined, {
    refetchOnMountOrArgChange: true,
    pollingInterval: RAFFLE_POLLING_MS,
  });
  const items = useMemo(
    () => selectBoard(result.data?.items ?? []),
    [result.data],
  );

  return {
    ...useClientPage(items),
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    errorMessage: getWheelRaffleErrorMessage(result.error),
  };
};
